import { ScopeStreams } from '@shared/app/scripts/services/scope-streams';
import wrapInSafeApplyFactory from '@global/wrap-in-safe-apply';

import { SchedulerLike } from 'rxjs';
import { fromEvent } from 'rxjs';
import { takeUntil, merge, filter, share, debounceTime } from 'rxjs/operators';

/**
 * A directive to bind to the enter event
 *
 * # Example
 * <any sw-enter="callback()">
 */
angular
  .module('coreModule')
  .directive(
    'swEnter',
    (
      $parse: ng.IParseService,
      $timeout: ng.ITimeoutService,
      scopeStreams: ScopeStreams,
      scheduler: SchedulerLike,
    ) => {
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, element, attrs, ctrl) {
          const swEnter = $parse(attrs.swEnter),
            DEBOUNCE = 500,
            E2E_DELAY = 500,
            wrapInSafeApply = wrapInSafeApplyFactory(scope),
            destroyed$ = scopeStreams.isDestroyed(scope);

          // raw events stream
          const keydown$ = fromEvent(element, 'keydown').pipe(
              takeUntil(destroyed$),
            ),
            keypress$ = fromEvent(element, 'keypress').pipe(
              takeUntil(destroyed$),
            );

          // all calls on enters - shared so they use the same listeners
          const react$ = keydown$.pipe(
            merge(keypress$),
            filter((event: KeyboardEvent) => event.which === 13),
            share(),
          );

          // we disable other event listeners for all <enter>
          react$.subscribe((event) => {
            event.preventDefault();
            event.stopPropagation();

            // let's the e2e know to wait
            $timeout(DEBOUNCE + E2E_DELAY);
          });

          // ignore all event within THROTTLE_TIME of reacting
          react$.pipe(debounceTime(DEBOUNCE, scheduler)).subscribe(
            wrapInSafeApply(() => {
              if (angular.isObject(ctrl)) {
                ctrl.$commitViewValue();
              }

              if (swEnter && angular.isFunction(swEnter)) {
                scope.$eval(swEnter);
              }
            }),
          );
        },
      };
    },
  );
